<loader-pane-fragment [trace]="traceName"></loader-pane-fragment>
<top-menu [showFilter]="true" [showPrint]="true" (filter)="filter()" [filtered]="!!actualFilterCount"></top-menu>
<mobile-menu></mobile-menu>
<div class="wrap920">
  <div class="tasks_header">
    <div class="title">Tasks</div>
    <div class="actions">
      <icon class="mobile" [ngClass]="{active: !!actualFilterCount}" (click)="filter()" icon="filter_24px"></icon>
    </div>
    <app-task-toggle-menu [lightDots]="true" [filterPage]="filterPage"></app-task-toggle-menu>
    <div class="tasks_loader">
      <mat-progress-bar *ngIf="!!eventPreferenceLoading || !!tasksLoading" mode="indeterminate"></mat-progress-bar>
    </div>
  </div>
  <div class="tasks_area" *ngIf="event && event.eventId">
    <app-task-list [placement]="isMyTasks ? 'my_tasks' : 'fullscreen'" [readonly]="!event || event.is_readonly || permissionsService.readonly[page_name]"></app-task-list>
  </div>
</div>